<template>
    <img :src="displaySrc" :alt="alt" :style="customStyle" />
</template>

<script>
import { getCachedImage } from '@/utils/request'

export default {
    name: 'CachedImage',
    props: {
        src: {
            type: String,
            default: ''
        },
        alt: {
            type: String,
            default: ''
        },
        customStyle: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            cachedSrc: ''
        }
    },
    computed: {
        displaySrc() {
            // 只有缓存加载完成后才显示图片，避免浏览器先请求原始 URL
            if (this.cachedSrc) {
                return this.cachedSrc
            }
            // 缓存未加载完成时返回空字符串，不发起请求
            return ''
        }
    },
    watch: {
        src: {
            immediate: true,
            handler(newSrc) {
                if (newSrc && newSrc !== '') {
                    this.loadImage(newSrc)
                }
            }
        }
    },
    methods: {
        async loadImage(imageUrl) {
            if (!imageUrl || imageUrl === '') return
            
            try {
                const base64 = await getCachedImage(imageUrl)
                if (base64 && base64 !== '') {
                    this.cachedSrc = base64
                    this.$emit('load', base64)
                }
            } catch (error) {
                console.error('加载图片失败:', error)
                this.$emit('error', error)
            }
        }
    }
}
</script>
